import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

export const ChallengeExpiry = ({ expiresAt, testId }) => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => { const timer = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(timer); }, []);
  const seconds = Math.max(0, Math.ceil((Date.parse(expiresAt) - now) / 1000));
  if (!Number.isFinite(seconds)) return null;
  return <span data-testid={testId} className={`inline-flex items-center gap-1 text-xs tabular-nums ${seconds ? "text-amber-200" : "text-white/50"}`}><Clock className="h-3 w-3" />{seconds ? `Closes in ${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}` : "Expired · closing safely"}</span>;
};